import { jsx } from "react/jsx-runtime";
import { Box, IconProfile, Text } from "braid-design-system";
import { avatarSize } from "./Avatar.css.mjs";
const stringToHexColour = ({
  name,
  colours
}) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colours.length;
  return colours[index];
};
const backgroundColours = [
  { value: "#F8B1DC", type: "customLight" },
  { value: "#C9DEFA", type: "customLight" },
  { value: "#FEDAC2", type: "customLight" },
  { value: "#FDC8C8", type: "customLight" },
  { value: "#F0D6FA", type: "customLight" }
];
const Avatar = ({
  name,
  variant,
  size = "standard",
  loading = false
}) => {
  if (loading) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: avatarSize[size],
        "aria-hidden": true,
        borderRadius: "full",
        background: "neutralLight"
      }
    );
  }
  const colour = stringToHexColour({
    name,
    colours: backgroundColours
  });
  const textContent = variant === "icon" ? /* @__PURE__ */ jsx(IconProfile, {}) : getInitials(name) ?? /* @__PURE__ */ jsx(IconProfile, { data: { testid: "fallback-icon" } });
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: avatarSize[size],
      "aria-hidden": true,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      background: colour.type,
      style: {
        background: colour.value
      },
      children: /* @__PURE__ */ jsx(Text, { weight: "strong", size, children: textContent })
    }
  );
};
const validCharactersRegex = new RegExp("\\p{L}", "u");
const getInitials = (fullName) => {
  let initials = "";
  const names = fullName.split(" ").filter((name) => name.length > 0 && validCharactersRegex.test(name[0]));
  for (const name of names) {
    if (initials.length === 1) {
      break;
    }
    initials = initials + name[0];
  }
  if (initials.length === 0) {
    return null;
  }
  return initials.toLocaleUpperCase();
};
export {
  Avatar
};
